module.exports = __webpack_public_path__ + "img/client-6.dc029fea.jpg";